export const sortByDate = (data, timestamp = "dttm") => {
    return data.sort((a, b) => {
        return new Date(a[timestamp]) - new Date(b[timestamp]);
    });
};

export const sortByDateInReverse = (data, timestamp = "dttm") => {
    return data.sort((a, b) => {
        return new Date(b[timestamp]) - new Date(a[timestamp]);
    });
};
